import {
  FAILED_STATUS,
  NON_RETRYABLE_ERROR_PATTERNS,
  RETRY_INTERVAL_MS,
  WINDOW_MS,
} from './config';
import { parseServerDate } from './time';

// Xato matni qayta urinish foydasiz bo'lgan sabablardan biriga mos keladimi
export function matchNonRetryable(error) {
  if (!error || typeof error !== 'string') return null;
  const hit = NON_RETRYABLE_ERROR_PATTERNS.find((item) => item.pattern.test(error));
  return hit ? hit.label : null;
}

// Bitta task bo'yicha qaror (sof funksiya — so'rov yubormaydi).
// Natija: { state, reason?, count, nextAt?, failedAt? }
//   state: 'ignore'    — failed emas (canceled, processing ...): umuman tegilmaydi
//          'skip'      — failed, lekin avtomatik urinilmaydi (reason bilan)
//          'waiting'   — keyingi urinish vaqti kelmagan (nextAt)
//          'due'       — urinish vaqti keldi
// Urinishlar soni cheklanmagan; count — faqat ma'lumot uchun.
export function evaluateTask(task, record, nowMs) {
  const count = record?.count || 0;
  if (!task || task.status !== FAILED_STATUS) return { state: 'ignore', count };

  const failedAt = parseServerDate(task.failed_at);
  if (failedAt === null) return { state: 'skip', reason: "failed_at yo'q", count };
  if (nowMs - failedAt > WINDOW_MS) return { state: 'skip', reason: '6 soatdan eski', count, failedAt };

  const nonRetryable = matchNonRetryable(task.error);
  if (nonRetryable) return { state: 'skip', reason: nonRetryable, count, failedAt };

  const base = Math.max(failedAt, record?.lastAt || 0);
  const nextAt = base + RETRY_INTERVAL_MS;
  if (nowMs < nextAt) return { state: 'waiting', count, nextAt, failedAt };
  return { state: 'due', count, nextAt, failedAt };
}

export const shortId = (taskId) => String(taskId || '').slice(0, 8);
